export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8958.88f16b88.jpg";